<div class="local-rest-api-token">
  @if (token()) {
    <input
      class="token-value"
      type="text"
      readonly
      [value]="token()"
      (focus)="$any($event.target).select()"
      [attr.aria-label]="T.GCF.MISC.LOCAL_REST_API_TOKEN | translate"
    />
  }
  @if (hasTokenError()) {
    <!-- The message is inserted after the panel has rendered, so without a live
         region a screen reader never announces that the token is unavailable. -->
    <p
      class="token-error"
      role="alert"
    >
      {{ T.GCF.MISC.LOCAL_REST_API_TOKEN_ERROR | translate }}
    </p>
  }
  <button
    mat-stroked-button
    color="primary"
    type="button"
    [disabled]="isRegenerating()"
    (click)="regenerate()"
  >
    {{ T.GCF.MISC.LOCAL_REST_API_TOKEN_REGENERATE | translate }}
  </button>
</div>
